const swiperShopByItem = document.querySelectorAll(".swiper-slide");
const numberItems = swiperShopByItem.length;

const rowsItem = numberItems > 7 ? 2 : 1;

//Initialize Swiper
new Swiper(".shop-by-carousel", {
  slidesPerView: 2,
  grid: {
    rows: rowsItem,
  },
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 5,
    },
    1100: {
      slidesPerView: 7,
    },
  },
});
